import { isSlotAfterNowInLocationTimezone } from "./DateAndFormat";

// Statuses (as sent by the backend in lastAppointments[].appointmentstatus) that
// do not hold the patient's slot. Compared lower-cased with spaces/dashes removed.
const NON_BLOCKING_STATUSES = ["cancelled", "canceled", "noshow"];

const statusKey = (status) =>
  String(status ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const isNonBlockingAppointmentStatus = (status) =>
  NON_BLOCKING_STATUSES.includes(statusKey(status));

// Timezone of the clinic an appointment belongs to: its own department's
// location when known, else the currently selected location's.
export const getAppointmentTimezone = (
  appointment,
  allLocations,
  fallbackTimezone,
) => {
  const appointmentLocation = allLocations?.find(
    (loc) => String(loc?.LocationId) === String(appointment?.departmentid),
  );
  return appointmentLocation?.timezone || fallbackTimezone;
};

// Upcoming = appointment date + start time is after now in the clinic timezone
// (so a later-today appointment is Upcoming); otherwise Prior. Status is
// deliberately ignored: a cancelled future appointment is still Upcoming.
export const isAppointmentUpcoming = (appointment, timezone) =>
  isSlotAfterNowInLocationTimezone(appointment, timezone);
